/** @type {import('zudoku').ZudokuConfig} */
import React from "react";
import { ApiKeyLink } from "./custome-pages/apiKeyLink";
import { ApiReference } from "./custome-pages/ApiReference";

const config = {
  plugins: [
    {
      getHead: () => <link rel="stylesheet" href="./search.css" />,
    },
  ],

  vite: { ssr: false }, // client-side only

  metadata: {
    title: "Vozzo Public API Documentation",
    description: "Comprehensive documentation for Vozzo's Public APIs",
    favicon: "./vz-fav.png",
    applicationName: "Vozzo API Docs",
  },

  theme: {
    themes: ["light"],
    defaultTheme: "light",
  },

  site: {
    logo: {
      src: { light: "/vozzo-new.png", dark: "/vozzo-dark-logo.png" },
      alt: "Vozzo",
      width: 70,
    },
    banner: {
      message: (
        <div className="text-center">
          Introducing Vozzo AI Labs APIs for smarter campaigns & call
          intelligence
        </div>
      ),
      dismissible: true,
    },
  },

  navigation: [
    {
      type: "category",
      label: "Documentation",
      icon: "book-open",
      items: [
        { type: "category", label: "Introduction", items: ["/introduction"] },
        {
          type: "category",
          label: "Authentication",
          items: ["/authentication"],
        },
        {
          type: "category",
          label: "Campaign Management",
          items: [
            "/campaigns/campaign-introduction",
            "/campaigns/campaign-quickstart",
            "/campaigns/campaign-apis-data-export",
            "/campaigns/creating-scheduling",
            "/campaigns/managing-campaigns",
            "/campaigns/campaign-analytics",
            "/campaigns/retry-time-intelligence",
            "/campaigns/multi-campaign-operations",
          ],
        },
        {
          type: "category",
          label: "Call Intelligence API",
          items: [
            "/call-intel-introduction",
            "/call-intel-manage-usecases",
            "/call-intel-upload",
            "/call-intel-analytics",
            "/call-intel-manage-recordings"
          ],
        },

        {
          type: "category",
          label: "Voice AI Agents",
          items: [
            "/agent-quickstart",
            "/agent-models",
            "/agent-voices-languages",
            "/agent-knowledge-files",
            "/agent-prompt",
            "/agent-greeting",
            "/agent-preview",
            "/agent-deploy-web",
            "/agent-deploy-phone",
            "/make-call",
            "/agent-workflow",
            "/agent-dashboard",
            "/agent-conversation-insights",
            "/agent-webhook-decryption",
          ],
        },
      ],
    },

    {
      type: "link",
      icon: "square-library",
      label: "API Reference",
      to: "/api-reference",
    },
    { type: "custom-page", path: "/api-reference", element: <ApiReference /> },
    {
      type: "custom-page",
      path: "/get-api-key",
      label: "Get API Key",
      icon: "key-round",
      element: <ApiKeyLink />,
    },
  ],

  redirects: [
    { from: "/", to: "/introduction" },
    { from: "/catalog", to: "/api-reference" },
  ],

  defaults: {
    apis: {
      examplesLanguage: "js",
      layout: { sidebar: false },
      disableSecurity: false,
    },
  },

  // Updated search configuration
  search: {
    type: "pagefind",
    showCloseButton: true,
    placeholder: "Search documentation...",
    className: "premium-search-modal",
  },

  apis: [
    {
      id: "call-intel",
      type: "file",
      input: "./apis/call-intel.json",
      path: "/api/call-intel",
    },
    {
      id: "campaigns",
      type: "file",
      input: "./apis/campaigns.json",
      path: "/api/campaigns",
    },
    {
      id: "agents",
      type: "file",
      input: "./apis/agents.json",
      path: "/api/agents",
    },
    {
      id: "make-call",
      type: "file",
      input: "./apis/make-call.json",
      path: "/api/make-call",
    },
  ],
};

export default config;
